<template lang='pug'>
  div(v-resize='onResize')
    slot(name='empty', v-if='!loading && !hasItems')
      v-container(fill-height)
        v-row(align='center' justify='center')
          .text-h5.grey--text {{noData}}
    slot(name='loading', v-if='loading && !hasItems')
      v-container(fill-height)
        v-row(align='center' justify='center')
          bionic-metrics-spinner
    div(v-if='hasItems')
      div(v-if='!listOnly && (!isSmall || tableOnly)')
        v-data-table(:headers='headers'
          :items='items'
          :search='search'
          :options.sync='options'
          v-on:update:options='emitUpdate'
          :server-items-length='total'
          :loading='loading'
          :item-key='itemKey'
          :show-select='selectAll'
          :single-select='singleSelect'
          :footer-props='{itemsPerPageOptions: rowsPerPage}'
          :disable-pagination='noPagination'
          :hide-default-footer='noPagination'
          v-bind:value='value'
          v-on:input='updateSelection')
          template(v-slot:item='props')
            tr(:active='props.isSelected' @click='props.select(!props.isSelected)')
              td(v-if='hasSelection' v-ripple)
                v-simple-checkbox(hide-details :value='props.isSelected' @input='props.select($event)')
              slot(name='row' :item='props.item' :index='props.index' v-ripple)
                // Fallback content
      div(v-if='!tableOnly && (isSmall || listOnly)')
        v-data-iterator(:items='items'
          :server-items-length='total'
          v-on:update:options='emitUpdate'
          :item-key='itemKey'
          :disable-pagination='noPagination'
          :hide-default-footer='noPagination'
          :footer-props='{itemsPerPageOptions: rowsPerPage}'
          :options.sync='options'
          content-tag='v-row'
          column)
          template(v-slot:item='props')
            slot(name='item' :item='props.item')
              // Fallback content

</template>

<script>
import _ from 'lodash';
import {mapGetters} from 'vuex';
import BionicMetricsSpinner from './Spinner';

export default {
  name: 'TableList',
  components: {BionicMetricsSpinner},
  props: {
    items: {
      required: true,
      default() {
        return [];
      }
    },
    selectAll: {
      type: Boolean,
      default: true
    },
    singleSelect: {
      type: Boolean,
      default: false
    },
    total: {
      type: Number,
      default: 0,
      required: true
    },
    headers: {
      required: true,
      default() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    noPagination: {
      type: Boolean,
      default: false
    },
    tableOnly: {
      type: Boolean,
      default: false
    },
    listOnly: {
      type: Boolean,
      default: false
    },
    search: {
      type: String,
      default: null
    },
    itemKey: {
      type: String,
      default: 'guid'
    },
    hasSelection: {
      type: Boolean,
      default: true
    },
    noData: {
      type: String,
      default() {
        return 'No Data';
      }
    },
    value: {
      default() {
        return [];
      }
    },
    initOptions: {
      default() {
        return {};
      }
    }
  },
  mounted() {
    this.options = {...this.options, ...this.initOptions};
    if (_.get(this.user, 'settings.rowsPerPage') && !this.initOptions.itemsPerPage) this.options.itemsPerPage = this.user.settings.rowsPerPage;
    this.$emit('update', this.options);
  },
  computed: {
    hasItems() {
      return this.items && this.items.length;
    },
    isSmall() {
      return this.screenSmall;
    },
    ...mapGetters({user: 'getUser'})
  },
  methods: {
    emitUpdate(options) {
      if (this.initial) {
        this.initial = false;
        return;
      }
      this.options = options;
      this.$emit('update', this.options);
    },
    updateSelection(selection) {
      this.$emit('input', selection);
    },
    onResize() {
      this.screenSmall = window.innerWidth < 960;
    }
  },
  data() {
    return {
      initial: true,
      screenSmall: true,
      rowsPerPage: [5, 10, 20, 50, 100],
      options: {
        page: 1,
        itemsPerPage: 10
      }
    };
  }
};
</script>

<style scoped>
</style>
